import router from './router'
import store from './store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
import { Message, Loading } from 'element-ui'
import {
  getToken,
  getTenantId,
  gotoNewWindow,
  setResourceFailedNum,
  getResourceFailedNum,
} from '@/utils/auth' // 验权
import { setWindowAuthInfo, getRouteJudge } from '@/utils/multiTenantUtil'
import { validateQuerySchema } from '@/utils/querySchema'
import extendRouter from '@/router/domain/index'
// import domainRouter from '@/router/domain/index'
// import leopardWebComponent from 'leopard-web-component' // 组件库判断403权限方法
import * as utils from '@/utils/index'
// import dynamicRoute from '@/components/custom-menu/utils/dynamicRoute/index.js'
import dynamicRoute from '@/components/OverLayout/components/custom-menu/utils/dynamicRoute/index'
import { purchaseMallLogIn } from '@/api/login'
import { upRoute } from '@/utils/ba.js'

const { routerTreeToArr } = dynamicRoute
routerTreeToArr('', extendRouter)
const noLogin = ['/login']
const whiteList = ['/welcome', '/404'] // 不重定向白名单
const baseName = router.history.base.replace('/', '') // 获取平台name
// eslint-disable-next-line no-shadow
function modMenuList(store, to, isWhite) {
  let name = ''
  const { addRouters } = store.state.permission || {}
  if (to.meta && to.meta.rootResourceKey) {
    name = to.meta.rootResourceKey
  } else if (to.path.split('/')[1] === 'welcome') {
    name = addRouters.length && addRouters[0].name
  } else {
    name = (to.path && to.path.split('/')[1]) || ''
  }
  const curList =
    addRouters && addRouters.find((item) => item.path === `/${name}`)
  if ((name && addRouters && curList && curList.children) || isWhite) {
    store.dispatch('changeMenu', {
      platformName: name,
      extendRouter,
    })
  }
}
// eslint-disable-next-line no-shadow
function doGetRoureceByToken(to, store, next) {
  store
    .dispatch('getResourceByToken', {
      token: getToken(),
      extendRouter,
      baseName,
    })
    .then(() => {
      // 请求数据
      router.addRoutes(store.getters.addRouters)
      store.commit('SET_ASYN_ROUTERS', router.options.routes)
      next({ ...to, replace: true })
      setResourceFailedNum(true)
    })
    .catch(() => {
      const failedCount = getResourceFailedNum()
      if (failedCount > 3) {
        setResourceFailedNum(true)
        store.dispatch('FedLogOut').then(() => {
          Message.warning(
            '多次尝试依然资源获取失败，可能网络环境不佳，请尝试重新登录',
          )
          next({ path: '/login' })
        })
      } else {
        setResourceFailedNum()
        Message.warning('账号暂无角色信息，请联系管理员绑定角色')
        doGetRoureceByToken(to, store, next)
      }
    })
}

router.beforeEach(async (to, from, next) => {
  // 上报埋点
  upRoute(to, from)
  // 跳转维保商城
  if (to.name === 'maintenanceMall') {
    next(false)
    purchaseMallLogIn({ phone: store.state.user.userInfo.userMobile, companyId: store.state.user.userInfo.sessionCompanyId }).then((res) => {
      if (res && res.code === 1) {
        utils.newOpenPage(res.data, 'shop')
      }
    }).finally(() => {
      window.location.reload()
    })

    return false
  }

  try {
    if (process.env.NODE_ENV === 'development') {
      validateQuerySchema(to)
    }
  } catch (err) {
    console.log(err)
  }

  const toPath = to.path.split('/')
  if (!whiteList.includes(`/${toPath[1]}`)) {
    if (toPath.length === 2) {
      const Menu = store.getters.addRouters.find((r) => r.name === toPath[1])
      if (Menu && Menu.children && Menu.children.length) {
        const item = Menu.children.find((r) => !r.hidden)
        if (item) {
          next({
            path: item.path,
          })
          return false
        }
      }
    }
  }
  utils.logEvent(to)
  NProgress.start()
  // false表示通过校验，true表示未通过校验,getTenantId()为-1的时候是跳转到登录，走之前处理
  if (getRouteJudge(to.path) && Number(getTenantId()) !== -1) {
    Loading.service()
    Message.error('账户租户权限更新，返回首页。')
    next(false)
    setTimeout(() => {
      gotoNewWindow()
    }, 2000)
  } else if (getToken() && getTenantId() > -1) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      const { userInfo } = store.getters
      if (getToken() && !userInfo.userName) {
        await Promise.all([store.dispatch('GetUserInfo', getToken())])
      }
      if (store.getters.addRouters.length === 0) {
        // 没有资源数据
        doGetRoureceByToken(to, store, next)
      } else {
        // 每次切换菜单 更新header中的代办数量
        if (to.path !== '/welcome' && getToken()) {
          store.dispatch('getTodoCount')
        }

        /**  进入页面后 缓存当前 路由 技改需求 20231031 https://bailongma.yuque.com/hhwu0d/nvrent/ivvalkzuuhe5yged */
        if (to.name && to.path !== '/login' && to.path !== '/welcome') {
          store.commit('ADD_CACHE_ROUTE', to)
        }
        // 判断是不是公司维度
        if (userInfo.sessionCompanyId && to.query.type === 'shop') {
          utils.jumpShopAddress(next)
          return
        }
        next()
      }
    }
  } else if (noLogin.indexOf(to.path) !== -1) {
    next()
  } else {
    next('/login') // 否则全部重定向到登录页
    NProgress.done()
  }
})

router.afterEach((to) => {
  setWindowAuthInfo()
  if (!whiteList.includes(to.path) && to.matched.length === 0) {
    // const path = to && to.path || ''
    // if (getPermission(path)) {
    //   router.replace({ path: '/403' })
    // } else {
    //   router.replace({ path: '/404' })
    // }
    router.push('/noPermission')
  }
  const { addRouters } = store.state.permission || {}
  const name = addRouters.length && addRouters[0].name
  if (name && to.path.split('/')[1] === 'welcome') {
    router.push(`/${name}`)
  }

  modMenuList(store, to, whiteList.includes(to.path)) // 一级菜单切换，二级菜单数据更新
  utils.setBreadcrumb(to, store, false)

  NProgress.done() // 结束Progress
})
